export const DictioneryPanel = {
    dashboard: {
        "fa": "داشبورد",
        "en": "Dashboard"
    },
    sell: {
        "fa": "فروش",
        "en": "sell"
    },
    soldTours: {
        "fa": "تور های فروخته شده",
        "en": "Sold tours"
    },
    sellTour: {
        "fa": "فروش تور",
        "en": "Sell tour"
    },
    soldHotels: {
        "fa": "هتل های فروخته شده",
        "en": "Sold hotels"
    },
    soldTourists: {
        "fa": "لیست مسافران",
        "en": "List of passengers"
    },
    baseInfo: {
        "fa": "تعاریف پایه",
        "en": "Basic definitions"
    },
    baseInfoTours: {
        "fa": "تور ها",
        "en": "Tours"
    },
    baseInfoHotels: {
        "fa": "هتل ها",
        "en": "Hotels"
    },
    baseInfoHotelsReq: {
        "fa": "درخواست هتل",
        "en": "Request Hotel"
    },
    baseInfoHotelsReqSended: {
        "fa": "هتل های درخواستی",
        "en": "Requested hotels"
    },
    baseInfoBrokers: {
        "fa": "کارگزارها",
        "en": "Brokers"
    },
    baseInfoAgencies: {
        "fa": "آژانس ها",
        "en": "Agencies"
    },
    reportBase: {
        "fa": "گزارش مدیریتی",
        "en": "Management report"
    },
    reportMonetary: {
        "fa": "گزارش مالی",
        "en": "Monetary report"
    },
    reportBaseIncoming: {
        "fa": "مسافران ورودی",
        "en": "incoming passengers"
    },
    reportBaseOutgoing: {
        "fa": "مسافران خروجی",
        "en": "incoming passengers"
    },
    reportBaseTrans: {
        "fa": "جابجایی مسافران",
        "en": "Transportation of passengers"
    },
    reportBaseHotels: {
        "fa": "هتل ها",
        "en": "Hotels"
    },
    reportBaseTours: {
        "fa": "تور ها",
        "en": "Tours"
    },
    settings: {
        "fa": "تنظیمات",
        "en": "Settings"
    },
    settingsSubs: {
        "fa": "اشتراک ها",
        "en": "Subscriptions"
    },
    settingsContract: {
        "fa": "قرارداد ها",
        "en": "Contracts"
    },
    reportMonetarySold: {
        "fa": "فروش تور",
        "en": "Tour sales"
    },
    dashboardDict: {
        editProfile: {
            "fa": "تنظیمات حساب کاربری",
            "en": "User account settings"
        },
        agencyName: {
            "fa": "نام آژانس",
            "en": "Agency Name"
        },
        brokerName: {
            "fa": "نام کارگزار",
            "en": "‌Broker Name"
        },
        agencyEnName: {
            "fa": "نام انگلیسی آژانس",
            "en": "Agency English Name"
        },
        brokerEnName: {
            "fa": "نام انگلیسی کارگزار",
            "en": "‌Broker English Name"
        },
        callNumber: {
            "fa": "شماره تماس",
            "en": "Call number"
        },
        email: {
            "fa": "آدرس ایمیل",
            "en": "Email address"
        },
        address: {
            "fa": "آدرس",
            "en": "Address"
        },
        city: {
            "fa": "شهر",
            "en": "City"
        },
        cityBase: {
            "fa": "شهر مبدا",
            "en": "Starting city "
        },
        cityDest: {
            "fa": "شهر مقصد",
            "en": "Destination city "
        },
        hotel: {
            "fa": "هتل",
            "en": "Hotel"
        },
        country: {
            "fa": "کشور",
            "en": "Country"
        },
        countryBase: {
            "fa": "کشور مبدا",
            "en": "Starting country"
        },
        countryDest: {
            "fa": "کشور مقصد",
            "en": "Destination country"
        },
        locLat: {
            "fa": "عرض جغرافیایی",
            "en": "Latitude"
        },
        locLon: {
            "fa": "طول جغرافیایی",
            "en": "Longitude"
        },
        postal: {
            "fa": "کد پستی",
            "en": "Postal code"
        },
        mainPic: {
            "fa": "عکس اصلی",
            "en": "Main photo"
        },
        logoPic: {
            "fa": "لوگو",
            "en": "Logo"
        },
        description: {
            "fa": "توضیحات",
            "en": "Description"
        },
        save: {
            "fa": "ذخیره",
            "en": "Save"
        },
        send: {
            "fa": "ارسال",
            "en": "Send"
        },
        uploadImage: {
            "fa": "برای انتخاب و اپلود کلیک کنید",
            "en": "Click to select and upload"
        },
        editAgency: {
            "fa": "ویرایش اطلاعات",
            "en": "Edit information"
        },
        brokersUnderContract:{
            "fa": "تعداد کارگزار های تحت قرارداد",
            "en": "Number of brokers under contract"
        },
        broker:{
            "fa": "کارگزار",
            "en": "Broker"
        },
        numberOfTours:{
            "fa": "تعداد تور های انجام شده",
            "en": "Number of tours done"
        },
        tour:{
            "fa": "تور",
            "en": "Tour"
        },
        totalRevenue:{
            "fa": "درآمد کلی آژانس",
            "en": "Total revenue of the agency"
        },
        currency:{
            "fa": "ریال",
            "en": "IRR"
        },
        editAgencyPopup:{
            "fa": "ویرایش  اطلاعات آژانس",
            "en": "Edit agency information"
        },
        tourtype:{
            "fa": "نوع تور"   ,
            "en": "Tour Type"
        },
        facility:{
            "fa": " امکانات"   ,
            "en": "Facility Type"
        },
        facilityvalue:{
            "fa": " مقدار"   ,
            "en": "Facility Value"
        },
    },
    fileDict: {
        select: {
            "fa": "انتخاب کنید",
            "en": "Select a item"
        },
        filemanager: {
            "fa": "فایل منیجر",
            "en": "File manager"
        },
        uploadFile: {
            "fa": "آپلود فایل",
            "en": "Upload file"
        },
        selectFile: {
            "fa": "انتخاب فایل",
            "en": "Select file"
        },
        file: {
            "fa": "فایل",
            "en": "File"
        },
        name: {
            "fa": "نام",
            "en": "Name"
        },
        tag: {
            "fa": "تگ",
            "en": "Tag"
        },
        send: {
            "fa": "ارسال",
            "en": "Send"
        },
        filter: {
            "fa": "فیلتر",
            "en": "Filter"
        },
        type: {
            "fa": "نوع",
            "en": "Type"
        },
        notFound: {
            "fa": "موجود نیست",
            "en": "Not Found"
        },
        delete: {
            "fa": "حذف",
            "en": "Delete"
        },
        edit: {
            "fa": "ویرایش",
            "en": "Edit"
        },
        confirm: {
            "fa": "آیا مطمئن هستید؟",
            "en": "Are you sure?"
        },
    },
    tourlists: {
        "fa": "لیست تور ها",
        "en": "Tour lists"
    },
    tourlistsDict: {
        category: {
            "fa": "ترتیب:",
            "en": "Sort:"
        },
        editTour: {
            "fa": "اضافه کردن  تور جدید",
            "en": "Add new Tour"
        },
        sellTour: {
            "fa": "فروش تور",
            "en": "Sell tour"
        },
        tourdate: {
            "fa": "اضافه کردن  تاریخ تور جدید",
            "en": "Add new  Date Tour"
        },
        departureDate: {
            "fa": "تاریخ حرکت",
            "en": "Departure date"
        },
        dapartureTime: {
            "fa": "زمان حرکت",
            "en": "Departure time"
        },
    },
    drivers: {
        "fa": "لیست رانندگان",
        "en": "Drivers"
    },
    leaders: {
        "fa": "لیست لیدرها",
        "en": "Leaders"
    },
    packages: {
        "fa": "پکیج ها",
        "en": "Packages"
    },
    packagesDict : {
        editTour: {
            "fa": "ویرایش تور",
            "en": "Edit tour"
        },
        tourname: {
            "fa": "نام تور",
            "en": "Tour name"
        },
        tourDesc: {
            "fa": "توضیحات تور",
            "en": "Tour description"
        },
        tourImage: {
            "fa": "عکس تور",
            "en": "Tour picture"
        },
        tourImageDesc: {
            "fa": "برای انتخاب و اپلود کلیک کنید",
            "en": "Click to select and upload"
        },
        addNewDate: {
            "fa": "اضافه کردن تاریخ جدید",
            "en": "Add new date"
        },
        goDate: {
            "fa": "تاریخ رفت",
            "en": "Departure date"
        },
        backDate: {
            "fa": "تاریخ برگشت",
            "en": "Return date"
        },
        tourCapacity: {
            "fa": "ظرفیت تور",
            "en": "Tour capacity"
        },
        tourCurrency: {
            "fa": "ارز تور",
            "en": "Tour Currency"
        },
        tourDateDesc: {
            "fa": "توضیحات اضافه",
            "en": "Additional description"
        },
        tourDatePrice: {
            "fa": "قیمت",
            "en": "Price"
        },
        addTourDetail: {
            "fa": "اضافه کردن اطلاعات جدید",
            "en": "Add new information"
        },
        startTour: {
            "fa": "شروع تور",
            "en": "Add new information"
        },
        endTour: {
            "fa": "پایان تور",
            "en": "Add new information"
        },
        hotelStar: {
            "fa": "تعداد ستاره",
            "en": "Number of stars"
        },
        tourDetailDesc: {
            "fa": "توضیحات",
            "en": "description"
        },
        tourAirline: {
            "en": "Airline name",
            "fa": "نام ایرلاین"
        },
        tourAirport: {
            "en": "departure airport Name",
            "fa": "نام فرودگاه مبدا"
        },
        tourdistAirport: {
            "en": "destination airport Name",
            "fa": "نام فرودگاه مقصد"
        },
        tourCargo: {
            "en": "Allowed cargo",
            "fa": "بار مجاز"
        },
        tourBus: {
            "en": "Bus type",
            "fa": "نوع اتوبوس"
        },
        tourTrain: {
            "en": "Train type",
            "fa": "نوع قطار"
        },
        tourShip: {
            "en": "Ship type",
            "fa": "نوع کشتی"
        },
        tourBoarding: {
            "en": "boarding place",
            "fa": "محل سوار شدن"
        },
    },
    agencies: {
        "fa": "لیست آژانس ها",
        "en": "Agencies"
    },
    agenciesDict: {
        noItem: {
            "fa": "موردی انتخاب نشده است!",
            "en": "Item not selected!"
        },
        chat: {
            "fa": "شروع چت",
            "en": "Start chat"
        },
        searchAgain: {
            "fa": "جستجوی مجدد",
            "en": "Search again"
        }
    },
    hotels: {
        "fa": "هتل ها",
        "en": "Hotels"
    },
    hotelsDict: {
        hotels: {
            "fa": "هتل ها",
            "en": "Hotels"
        },
        addHotel: {
            "fa": "افزودن هتل جدید",
            "en": "Add new hotel"
        },
        deleteHotel: {
            "fa": "آبا از حذف [hotelname] مطمئن هستید؟",
            "en": "Are you sure to delete [hotelname]?"
        },
        addHotelRoom: {
            "fa": "افزودن اتاق",
            "en": "Add hotel room"
        },
        price: {
            "fa": "قیمت",
            "en": "Price"
        },
        amount: {
            "fa": "تعداد",
            "en": "Amount"
        },
        currency: {
            "fa": "ارز",
            "en": "currency"
        },
        formName: {
            "fa": "نام",
            "en": "Name"
        },
        formEnName: {
            "fa": "نام انگلیسی",
            "en": "English name"
        },
        formRoomType: {
            "fa": "نوع اتاق",
            "en": "Room Type"
        },
        formRoomInfo: {
            "fa": "اطلاعات",
            "en": "Info"
        },
        formRoomDesc: {
            "fa": "توضیحات",
            "en": "Description"
        },
        formCount: {
            "fa": "تعداد",
            "en": "Count"
        },
        formCountNow: {
            "fa": "تعداد موجود",
            "en": "In stock count"
        },
        formControl: {
            "fa": "کنترل",
            "en": "Control"
        },
        formControlActive: {
            "fa": "فعال",
            "en": "Active"
        }
    },
    backPage: {
        "fa": "مرحله قبل",
        "en": "Previous step"
    },
    nextPage: {
        "fa": "مرحله بعد",
        "en": "Next step"
    },
    nextSavePage: {
        "fa": "ذخیره و مرحله بعد",
        "en": "Save & Next step"
    },
    finishPage: {
        "fa": "تایید و ذخیره",
        "en": "ٰVerify & save"
    },
    access: {
        "fa": "دسترسی کاربران",
        "en": "Access"
    },
    wallet: {
        "fa": "کیف پول",
        "en": "Wallet"
    },
    walletDict: {
        removable: {
            "fa": "قابل برداشت",
            "en": "Removable"
        },
        scoreTotal: {
            "fa": "مجموع امتیاز",
            "en": "Total score"
        },
        all: {
            "fa": "موجودی",
            "en": "Balance"
        },
        recive: {
            "fa": "واریز به حساب",
            "en": "Deposit to the account"
        },
        transactions: {
            "fa": "لیست تراکنش ها",
            "en": "Transactions"
        },
        allIncome: {
            "fa": "مجموع واریز",
            "en": "Total deposit"
        },
        allWithdrawal: {
            "fa": "مجموع برداشت",
            "en": "Total withdrawal"
        },
        allRemaining: {
            "fa": "مجموع باقی مانده",
            "en": "Total remaining"
        },
        filterTitle: {
            "fa": "دسته بندی بر اساس:",
            "en": "Group by:"
        },
        filterAll: {
            "fa": "همه",
            "en": "All"
        },
        filterSearch: {
            "fa": "جستجو کنید ...",
            "en": "Search ..."
        },
        tableIncome: {
            "fa": "واریز",
            "en": "Deposit"
        },
        tableWithdrawal: {
            "fa": "برداشت",
            "en": "withdrawal"
        },
        score: {
            "fa": "امتیاز",
            "en": "Score"
        },
        tableDate: {
            "fa": "تاریخ",
            "en": "Date"
        },
        tableType: {
            "fa": "نوع",
            "en": "Type"
        },
        tableCharge: {
            "fa": "کارمزد",
            "en": "Charge"
        },
        tableSituation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        active: {
            "fa": "فعال",
            "en": "Active"
        },
    },
    accessDict: {
        add: {
            "fa": "اضافه کردن ادمین جدید",
            "en": "Add new admin"
        },
        addDriver: {
            "fa": "اضافه کردن راننده جدید",
            "en": "Add new driver"
        },
        addLeader: {
            "fa": "اضافه کردن لیدر جدید",
            "en": "Add new leader"
        },
        edit: {
            "fa": "ویرایش",
            "en": "Edit"
        },
        trash: {
            "fa": "حذف",
            "en": "Delete"
        },
        countryCity: {
            "fa": "شهرو/کشور:",
            "en": "City/Country:"
        },
        numberTours: {
            "fa": "تعداد تور های انجام شده:",
            "en": "Number of tours:"
        },
        Tour: {
            "fa": "تور",
            "en": "Tour"
        },
        deleteUser: {
            "fa": "آیا از حذف کاربر مطمئن هستید؟",
            "en": "Are you sure you want to delete the user?"
        },
        newUser: {
            "fa": "کاربر",
            "en": "User"
        },
        newDriver: {
            "fa": "راننده",
            "en": "Driver"
        },
        newLeader: {
            "fa": "لیدر",
            "en": "Leader"
        },
        email: {
            "fa": "ایمیل",
            "en": "Email"
        },
        name: {
            "fa": "نام و نام خانوادگی",
            "en": "First name & last name"
        },
        accesses: {
            "fa": "دسترسی ها",
            "en": "Access"
        },
    },
    chats: {
        "fa": "صفحه چت",
        "en": "Chats"
    },
    chatsDict: {
        sendMessagePlaceholder: {
            "fa": "پیام ...",
            "en": "Message ..."
        },
        noItem: {
            "fa": "برای شروع یک پیام ارسال کنید!",
            "en": "Send a message to get started!"
        },
    },
    campaigns: {
        "fa": "مدریت آگهی ها",
        "en": "Campaigns"
    },
    brokers: {
        "fa": "لیست کارگزاران",
        "en": "Brokers"
    },
    tourists: {
        "fa": "لیست مسافران",
        "en": "Tourists"
    },
    soldPackages: {
        "fa": "پکیج و تور های فروخته شده",
        "en": "Sold packages & tours "
    },
    incomeTourist: {
        "fa": "مسافران ارجاعی",
        "en": "Referral passengers "
    },
    touristsDict: {
        dateFilter: {
            "fa": "فیلتر تاریخ",
            "en": "Date filtrer"
        },
        selected: {
            "fa": "انتخاب شده",
            "en": "Selected"
        },
        selectTour: {
            "fa": "یک تور انتخاب کنید",
            "en": "Select a tour"
        },
        newList: {
            "fa": "لیست جدید",
            "en": "New list"
        },
        Tour: {
            "fa": "تور",
            "en": "Tour"
        },
        Date: {
            "fa": "تاریخ",
            "en": "Date"
        },
        sellerPersonel: {
            "fa": "فروشنده",
            "en": "Seller"
        },
        Hotel: {
            "fa": "هتل",
            "en": "Hotel"
        },
        allHotels: {
            "fa": "همه هتل ها",
            "en": "All hotels"
        },
        HotelRooms: {
            "fa": "اتاق های هتل",
            "en": "Hotel Rooms"
        },
        selectDate: {
            "fa": "انتخاب تاریخ",
            "en": "Select date"
        },
        addNewDate: {
            "fa": "افزودن تاریخ جدید",
            "en": "Add new date"
        },
        addNewPerson: {
            "fa": "اضافه کردن مسافر جدید",
            "en": "Add new passenger"
        },
        addNewHotelRoom: {
            "fa": "اضافه کردن اتاق جدید",
            "en": "Add new hotel room"
        },
        addNewPartialPrice: {
            "fa": "اضافه کردن پرداخت جدید",
            "en": "Add new payment"
        },
        personName: {
            "fa": "نام و نام خانوادگی",
            "en": "First name & last name"
        },
        personCompanyNum: {
            "fa": "تعداد",
            "en": "No. passengers"
        },
        personNationalID: {
            "fa": "کد ملی",
            "en": "National ID"
        },
        personBirthday: {
            "fa": "تاریخ تولد",
            "en": "Birthdate"
        },
        personPassportID: {
            "fa": "شماره پاسپورت",
            "en": "Passport number"
        },
        personPassportExp: {
            "fa": "تاریخ انقضای پاسپورت",
            "en": "Expiry date of passport"
        },
        personMobile: {
            "fa": "موبایل",
            "en": "Mobile"
        },
        personEmail: {
            "fa": "ایمیل",
            "en": "Email"
        },
        personMain: {
            "fa": "سرپرست",
            "en": "supervisor"
        },
        personSec: {
            "fa": "مسافر همراه",
            "en": "Accompanying passenger"
        },
        personelMain: {
            "fa": "پرسنل",
            "en": "Personel"
        },
        personelMainName: {
            "fa": "نام",
            "en": "Name"
        },
        noFilter: {
            "fa": "برای مشاهده، فیلتر کشور و شهر را پر کنید",
            "en": "To view, fill in the country and city filter"
        },
        index: {
            "fa": "ردیف",
            "en": "Index"
        },
        select: {
            "fa": "انتخاب",
            "en": "select"
        },
        Name: {
            "fa": "نام",
            "en": "Name"
        },
        dateDepart: {
            "fa": "تاریخ رفت",
            "en": "Departure date"
        },
        dateReturn: {
            "fa": "تاریخ برگشت",
            "en": "Return date"
        },
        hotelRoom: {
            "fa": "اتاق",
            "en": "Room"
        },
        hotelExtras: {
            "fa": "اضافات",
            "en": "Extras"
        },
        hotelServices: {
            "fa": "سرویس ها",
            "en": "Services"
        },
        hotelMeals: {
            "fa": "غذاها",
            "en": "Meals"
        },
        hotelRoomInfo: {
            "fa": "اطلاعات اتاق",
            "en": "Room info"
        },
        priceCount: {
            "fa": "تعداد",
            "en": "Count:"
        },
        priceCount: {
            "fa": "تعداد",
            "en": "Count:"
        },
        checkinDate: {
            "fa": "تاریخ ورود",
            "en": "Checkin date"
        },
        checkoutDate: {
            "fa": "تاریخ خروج",
            "en": "Checkout date"
        },
        passengerCount: {
            "fa": "تعداد مسافر",
            "en": "Passenger count"
        },
        pricePerPerson: {
            "fa": "قیمت هر نفر",
            "en": "Price per person"
        },
        flightNo: {
            "fa": "شماره پرواز",
            "en": "Flight number"
        },
        TicketNo: {
            "fa": "شماره بلیط",
            "en": "Ticket number"
        },
        priceTickets: {
            "fa": "جمع قیمت بلیط ها",
            "en": "Total price of tickets"
        },
        priceHotels: {
            "fa": "جمع قیمت اتاق ها",
            "en": "Total price of rooms"
        },
        pricePartial: {
            "fa": "مقدار",
            "en": "Price"
        },
        priceTotal: {
            "fa": "قیمت کل",
            "en": "Price total"
        },
        noPasenger: {
            "fa": "تعداد مسافرین",
            "en": "Number of passengers"
        },
        noPasengerNotSend: {
            "fa": "اطلاعات ارسال نشده",
            "en": "Information not sent"
        },
        noPasengerNotSendToBroker: {
            "fa": "ارسال اطلاعات مسافران",
            "en": "Send passenger information"
        },
        pasenger: {
            "fa": "مسافر",
            "en": "Pasenger"
        },
        personSecTable: {
            "fa": "به همراه",
            "en": "Along with"
        },
        pasengerNoTable: {
            "fa": "نفر دیگر",
            "en": "other person"
        },
        actions: {
            "fa": "اکشن ها",
            "en": "Actions"
        },
        editTouristData: {
            "fa": "ویرایش",
            "en": "Edit"
        },
        addPersonel: {
            "fa": "اضافه کردن پرسنل",
            "en": "Add personel"
        },
        infoPassenger: {
            "fa": "اطلاعات مسافر",
            "en": "Passenger Info"
        },
        passengerDriver: {
            "fa": "راننده",
            "en": "Driver"
        },
        passengerLeader: {
            "fa": "لیدر",
            "en": "Leader"
        },
        passengerTickets: {
            "fa": "بلیط ها",
            "en": "Tickets"
        },
        passengerPakcages: {
            "fa": "پکیج",
            "en": "Package"
        },
        passengerAddPakcage: {
            "fa": "افزودن پکیج",
            "en": "Add package"
        },
        passengerAddPersonel: {
            "fa": "افزودن پرسنل",
            "en": "Add personel"
        },
        passengerTicketsType: {
            "fa": "نوع",
            "en": "Type"
        },
        passengerTicketsDate: {
            "fa": "تاریخ",
            "en": "Date"
        },
        passengerTicketsTime: {
            "fa": "زمان",
            "en": "Time"
        },
        passengerHotels: {
            "fa": "هتل ها",
            "en": "Hotels"
        },
        passengerRoom: {
            "fa": "اتاق",
            "en": "Room"
        },
        passengerPakcageName: {
            "fa": "نام پکیج",
            "en": "Package name"
        },
        passengerPakcagePrice: {
            "fa": "قیمت",
            "en": "Price"
        },
        passengerPersonel: {
            "fa": "پرسنل",
            "en": "Personel"
        },
    },
    tourname: {
        "fa": "نام تور",
        "en": "Tour Name"
    },
    tourdesc: {
        "fa": "شرح  تور",
        "en": "Tour DEscription"
    },
    tourprice: {
        "fa": "قیمت  تور",
        "en": "Tour Price"
    },
    tourComissionPrice: {
        "fa": "کمیسیون ثابت",
        "en": "Fixed commission"
    },
    tourComissionPercent: {
        "fa": "کمیسیون درصدی",
        "en": "Percentage commission"
    },
    tourcapacity: {
        "fa": "ظرفیت  تور",
        "en": "Tour Capacity"
    },
    Departure_Date: {
        "fa": "تاریخ  رفت",
        "en": "Departure Date"
    },
    Return_Date: {
        "fa": "تاریخ  برگشت",
        "en": "Return Date"
    },
    addtourdate: {
        "fa": "اضافه کردن تاریخ تور  ",
        "en": "Add New Date Tour"
    },
    addtourdetail: {
        "fa": "اضافه کردن جزئیات تور  ",
        "en": "Add New Detail Tour"
    },
    addtourhotel: {
        "fa": "اضافه کردن هتل های تور  ",
        "en": "Add New Hotels Tour"
    },
    broker: {
        "fa": "کارگزار",
        "en": "broker",
    },
    hotel: {
        "fa": "هتل",
        "en": "hotel",
    },
    reports: {
        "fa": "گزارش ها",
        "en": "Reports"
    },
    reportsDict: {
        passengerIntry: {
            "fa": "گزارش جابه‌جایی مسافر",
            "en": "Passenger displacement report"
        },
        passengerEnterance: {
            "fa": "گزارش مسافر ورودی",
            "en": "Passenger enterance report"
        },
        passengerDeparture: {
            "fa": "گزارش مسافر خروجی",
            "en": "Passenger departure report"
        },
        hotelIntry: {
            "fa": "گزارش هتل های فروخته شده",
            "en": "Report of sold hotels"
        },
        hotelVoucher: {
            "fa": "ووچر هتل",
            "en": "Hotel Voucher"
        },
        situation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        situationAll: {
            "fa": "همه",
            "en": "all"
        },
        situationConfirmed: {
            "fa": "تایید شده",
            "en": "Confirmed"
        },
        situationNotConfirmed: {
            "fa": "تایید نشده",
            "en": "Not confirmed"
        },
        situationRejected: {
            "fa": "رد شده",
            "en": "Rejected"
        },
        notFound: {
            "fa": "موردی یافت نشد",
            "en": "Nothing found"
        },
        NoName: {
            "fa": "ردیف",
            "en": "No"
        },
        agencyName: {
            "fa": "نام آژانس",
            "en": "Agency name"
        },
        hotelName: {
            "fa": "نام هتل",
            "en": "Hotel name"
        },
        personelNumber: {
            "fa": "تعداد پرسنل",
            "en": "Number of personnel"
        },
        roomName: {
            "fa": "نام اتاق",
            "en": "Room name"
        },
        checkin: {
            "fa": "ورود",
            "en": "Check-in"
        },
        checkout: {
            "fa": "خروج",
            "en": "Check-out"
        },
        count: {
            "fa": "تعداد",
            "en": "Count"
        },
        price: {
            "fa": "قیمت",
            "en": "Price"
        },
        situation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        action: {
            "fa": "اکشن",
            "en": "Action"
        },
        actionDetail: {
            "fa": "اطلاعات",
            "en": "Info"
        },
        verifyHotel: {
            "fa": "تایید",
            "en": "Verify"
        },
        toNotConfirmedHotel: {
            "fa": "به تایید نشده",
            "en": "To not confirmed"
        },
        rejectHotel: {
            "fa": "رد کردن",
            "en": "Reject"
        },
        rejectReasonHotel: {
            "fa": "دلیل رد کردن",
            "en": "Rejecting reason"
        },
        sendBrokerReq: {
            "fa": "ارسال درخواست",
            "en": "Send request"
        },
        sendBrokerReqReject: {
            "fa": "رد درخواست",
            "en": "Reject request"
        },
        sendBrokerReqConfirm: {
            "fa": "تایید درخواست",
            "en": "Confirm request"
        },
        sendBrokerReqShow: {
            "fa": "مشاهده درخواست",
            "en": "Show request"
        },
        sendBrokerReqRejected: {
            "fa": "رد شده",
            "en": "Rejected"
        },
        sendBrokerReqRejected: {
            "fa": "رد شده",
            "en": "Rejected"
        },
        sendBrokerReqSent: {
            "fa": "ارسال شده",
            "en": "Sent"
        },
        sendBrokerReqConfirmed: {
            "fa": "تایید شده",
            "en": "Confirmed"
        },
        sendBrokerReqText: {
            "fa": "متن درخواست",
            "en": "Request text"
        },
        ticketType: {
            "fa": "نوع بلیط",
            "en": "Ticket type"
        },
        ticketTransfereType: {
            "fa": "مسیر",
            "en": "route"
        },
        parentUser: {
            "fa": "مسافر سرپرست",
            "en": "Main passenger"
        },
        dateFlight: {
            "fa": "تاریخ بلیط",
            "en": "Ticket date"
        },
        timeFlight: {
            "fa": "زمان بلیط",
            "en": "Ticket time"
        },
        passengerCount: {
            "fa": "تعداد مسافرین",
            "en": "Passenger count"
        },
        flightNo: {
            "fa": "شماره بلیط",
            "en": "Ticket Number"
        },
        airline: {
            "fa": "ایرلاین",
            "en": "Airline"
        },
        depAirport: {
            "fa": "ترمینال مبدا",
            "en": "Departure terminal"
        },
        desAirport: {
            "fa": "ترمینال مقصد",
            "en": "Destination terminal"
        },
        hotelName: {
            "fa": "نام هتل",
            "en": "Hotel name"
        },
        DateIssue: {
            "fa": "تاریخ:",
            "en": "date:"
        },
        fromDate: {
            "fa": "از تاریخ:",
            "en": "From date:"
        },
        toDate: {
            "fa": "تا تاریخ:",
            "en": "To date:"
        },
        PNR: {
            "fa": "شماره مسافر:",
            "en": "PNR:"
        },
        NumberOfRooms: {
            "fa": "تعداد اتاق:",
            "en": "Number of rooms:"
        },
        Name: {
            "fa": "نام",
            "en": "Name"
        },
        mobile: {
            "fa": "موبایل",
            "en": "Mobile"
        },
        email: {
            "fa": "ایمیل",
            "en": "Email"
        },
        address: {
            "fa": "آدرس",
            "en": "Address"
        },
        Callnumber: {
            "fa": "تلفن تماس",
            "en": "Call Number"
        },
    },
    settings: {
        "fa": "تنظیمات",
        "en": "Settings"
    },
    invite: {
        "fa": "دعوت از دوستان",
        "en": "Invite friends"
    },
    inviteDict: {
        inviteLink: {
            "fa": "لینک اختصاصی شما",
            "en": "Your exclusive link"
        },
        copylink: {
            "fa": "کپی لینک",
            "en": "Copy link"
        },
        copylinkOkay: {
            "fa": "لینک کپی شد",
            "en": "The link was copied"
        },
        scoreTotal: {
            "fa": "مجموع امتیازات",
            "en": "Total score"
        },
        inviteTotal: {
            "fa": "تعداد دوستان",
            "en": "Number of friends"
        },
    },
    notifOn: {
        "fa": "روشن کردن نوتیفیکیشن",
        "en": "Turn on notification"
    },
    notifOff: {
        "fa": "خاموش کردن نوتیفیکیشن",
        "en": "Turn off notification"
    },
    addAgency: {
        "fa": "ثبت نام آژانس جدید",
        "en": "New agency registration"
    },
    saveData: {
        "fa": "ذخیره اطلاعات",
        "en": "Save information"
    },
    addBroker: {
        "fa": "ثبت نام کارگزار جدید",
        "en": "New Broker registration"
    },
    typesTransfereDict: {
        type: {
            "fa": "نوع مسیر",
            "en": "Transfer type"
        },
        type1: {
            "fa": "ورودی",
            "en": "Entrance"
        },
        type2: {
            "fa": "بین شهری",
            "en": "Intercity"
        },
        type3: {
            "fa": "خروجی",
            "en": "Departure"
        },
    },
    filterDict: {
        country: {
            "fa": "کشور",
            "en": "Country"
        },
        city: {
            "fa": "شهر",
            "en": "City"
        },
        type: {
            "fa": "نوع",
            "en": "Type"
        },
        name: {
            "fa": "نام",
            "en": "Name"
        },
    },
    tableDict: {
        registerContract: {
            "fa": "ثبت پیش قرارداد",
            "en": "register Pre-contract registr"
        },
        print: {
            "fa": "پرینت",
            "en": "Print"
        },
        sendHotelReq: {
            "fa": "ارسال درخواست رزرو هتل",
            "en": "Send a hotel reservation request"
        },
        sendToBroker: {
            "fa": "ارسال اطلاعات به کارگزار",
            "en": "Send information to the broker"
        },
        agenciesCon: {
            "fa": "درخواست های همکاری",
            "en": "Cooperation requests"
        },
        agency_name: {
            "fa": "نام آژانس",
            "en": "Agency Name"
        },
        agency_contracted: {
            "fa": "تحت قرارداد",
            "en": "Contracted"
        },
        agency_chat: {
            "fa": "شروع چت",
            "en": "Start chat"
        },
        agency_req: {
            "fa": "ارسال درخواست",
            "en": "Send request"
        },
        broker_name: {
            "fa": "نام کارگزار",
            "en": "Broker Name"
        },
        hotelName: {
            "fa": "نام هتل",
            "en": "Hotel name"
        },
        hotelroomName: {
            "fa": "نوع اتاق",
            "en": "Room type"
        },
        currency: {
            "fa": "ارز",
            "en": "Currency"
        },
        price: {
            "fa": "قیمت",
            "en": "Price"
        },
        count: {
            "fa": "تعداد",
            "en": "Count"
        },
        countMax: {
            "fa": "حداکثر تعداد",
            "en": "Maximum count"
        },
        dateFrom: {
            "fa": "از تاریخ",
            "en": "From Date"
        },
        dateTo: {
            "fa": "تا تاریخ",
            "en": "To Date"
        },
        situation: {
            "fa": "وضعیت",
            "en": "Situation"
        },
        reject: {
            "fa": "رد",
            "en": "Reject"
        },
        confirm: {
            "fa": "تایید",
            "en": "Confirm"
        },
        cancel: {
            "fa": "کنسل",
            "en": "Cancel"
        },
    },
    contractsDict: {
        title: {
            "fa": "قرارداد ها",
            "en": "Contracts"
        },
        addNewContract: {
            "fa": "قرارداد جدید",
            "en": "New Contract"
        },
        contract: {
            "fa": "قرارداد",
            "en": "Contract"
        },
    },
}